'use client';
import { useState } from 'react';
import type { WizardCtx } from '../types';
import { StepLayout, PrimaryBtn } from '../shared';

type Prefs = { new_session: boolean; new_message: boolean; link_request: boolean; push: boolean; email: boolean };

export function NotifStep({ ctx }: { ctx: WizardCtx }) {
  const [prefs, setPrefs] = useState<Prefs>({
    new_session: true, new_message: true, link_request: true, push: true, email: true,
  });
  const toggle = (k: keyof Prefs) => setPrefs(p => ({ ...p, [k]: !p[k] }));

  return (
    <StepLayout
      narrow
      eyebrow="STEP 05 · NOTIFICATIONS"
      title="Stay in the loop"
      sub="Pick what you want pinged about. Tweak any time from Settings."
    >
      <div className="ob-notif">
        <NotifRow label="Someone opens a chat with your avatar" sub="When a seeker starts a conversation" on={prefs.new_session} onToggle={() => toggle('new_session')} />
        <NotifRow label="New messages" sub="New messages in your active chats" on={prefs.new_message} onToggle={() => toggle('new_message')} />
        <NotifRow label="Link requests" sub="When someone asks to connect for real" on={prefs.link_request} onToggle={() => toggle('link_request')} />
      </div>

      <div className="ob-notif-channel">
        <span className="ob-label" style={{ margin: 0 }}>Send via</span>
        <div className="ob-row" style={{ gap: 8 }}>
          <button className={`ob-chip ${prefs.push ? 'ob-chip--on' : ''}`} onClick={() => toggle('push')}>Push</button>
          <button className={`ob-chip ${prefs.email ? 'ob-chip--on' : ''}`} onClick={() => toggle('email')}>Email</button>
        </div>
      </div>

      <PrimaryBtn full onClick={ctx.next}>Save preferences</PrimaryBtn>
    </StepLayout>
  );
}

function NotifRow({ label, sub, on, onToggle }: { label: string; sub: string; on: boolean; onToggle: () => void }) {
  return (
    <button className="ob-notif-row" onClick={onToggle}>
      <div style={{ flex: 1 }}>
        <div className="ob-notif-label">{label}</div>
        <div className="ob-notif-sub">{sub}</div>
      </div>
      <button type="button" className={`sp-toggle ${on ? 'is-on' : ''}`}
        onClick={e => { e.stopPropagation(); onToggle(); }}
        aria-checked={on} role="switch">
        <div className="sp-toggle-knob" />
      </button>
    </button>
  );
}
